export const SET_USER_COURSE_ROLE = 'SET_USER_COURSE_ROLE'
export const SET_COURSE_APPROVAL_STATUS = 'SET_COURSE_APPROVAL_STATUS'